import React from "react"
import { AppBulkEditAction } from "@components"

import { useUserSettingsSite, useUserSettingsSiteValidator } from "../../../@hooks"


export default function UserSettingSiteDrawerSubmit() {
	const { isLoading, handleSubmitSitesFormData } = useUserSettingsSite()
	const { isValid } = useUserSettingsSiteValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitSitesFormData}
	>
		Save
	</AppBulkEditAction>
}